export default "__VITE_ASSET__u3Lfs03C__"